import { isFuture } from 'date-fns'
import { z } from 'zod'

import i18n from '@/i18n'

export const formSchema = z
  .object({
    archiveMode: z.enum(['now', 'scheduled']),
    archiveDate: z.date().optional()
  })
  .superRefine((data, ctx) => {
    if (data.archiveMode === 'now') return

    if (!data.archiveDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('error.required-field-with-label', {
          ns: 'common',
          LABEL: i18n.t('label.date', { ns: 'common' })
        }),
        path: ['archiveDate']
      })
      return
    }

    if (!isFuture(data.archiveDate)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('error.date-must-be-in-future', {
          ns: 'common'
        }),
        path: ['archiveDate']
      })
    }
  })

export type FormSchema = z.infer<typeof formSchema>
